import { Box, Button, Container, Dialog, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useFormStyles } from '../pages/Auth/authStyles';
import loginLogo from '../assets/svg/new-logo-with-title-white.svg';
import { Colors } from '../assets/theme/Colors';
import useHasActiveFeatureFlag from '../hooks/useFeatureFlags';
import { FF_NATIVE_UPDATE_PROMPT } from './FeatureFlagWrapper';

const NativeAppUpdateAvailable = ({ show, onUpdateClick }) => {
  const authStyles = useFormStyles();
  const theme = useTheme();
  const offset = `calc(${theme.mixins.toolbar.minHeight + 8}px + var(--ion-safe-area-top))`;
  const hasNativeUpdatePromptFF = useHasActiveFeatureFlag(FF_NATIVE_UPDATE_PROMPT);

  if (!hasNativeUpdatePromptFF) {
    return null;
  }

  if (!show) {
    return null;
  }

  return (
    <Box>
      <Dialog
        disablePortal
        open
        sx={{
          position: 'absolute',
          zIndex: 1400,
          '.MuiPaper-root': { mx: 1, marginTop: offset },
          '& .MuiDialog-container': {
            alignItems: 'flex-start',
          },
        }}
      >
        <Box sx={authStyles.pageBackground}>
          <Container maxWidth="md">
            <Grid container spacing={2} sx={authStyles.pageContainer} data-testid="login-container">
              <Grid
                item
                xs
                sx={{
                  padding: '16px 0 !important',
                  width: '100%',
                }}
              >
                <Grid item xs sx={[authStyles.logoWrapper, { py: 3 }]}>
                  <Box component="img" src={loginLogo} alt="logo" sx={authStyles.logo} />
                </Grid>

                <Grid item xs sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Box
                    sx={{
                      maxWidth: 'fit-content',
                      padding: { xs: '16px', sm: '16px 32px' },
                    }}
                  >
                    <Typography
                      sx={{ color: Colors.white, fontWeight: 700, textAlign: 'center', pb: 2 }}
                      variant="body1"
                    >
                      App update
                    </Typography>
                    <Typography
                      sx={{ color: Colors.white, fontWeight: 500, textAlign: 'center', pb: 2 }}
                      variant="body1"
                    >
                      There is a new version of the app available
                    </Typography>
                    <Box sx={{ py: 2, textAlign: 'center' }} onClick={onUpdateClick}>
                      <Button variant="contained" color="secondary" fullWidth sx={{ textTransform: 'none' }}>
                        Update now
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Dialog>
    </Box>
  );
};

export default NativeAppUpdateAvailable;
